import type { UserRole } from "./auth-api";

export type AdminAccessKey =
  | "canViewDashboard"
  | "canViewCandidateUsers"
  | "canManageUsers"
  | "canResetUserPassword"
  | "canImpersonateCandidate"
  | "canManageSystem"
  | "canViewAuditLogs"
  | "canManageQuestions"
  | "canArchiveQuestions"
  | "canDeleteQuestions"
  | "canPublishQuestions"
  | "canManageQuestionExperience"
  | "canManagePapers"
  | "canManageExams"
  | "canViewExecution"
  | "canViewDocker"
  | "canManageAssets"
  | "canReview";

export type AdminPermissionMatrixItem = {
  key: AdminAccessKey;
  labelMessageId: `admin.rolePermissions.permissions.${string}`;
  roles: UserRole[];
};

export const ADMIN_PERMISSION_MATRIX: AdminPermissionMatrixItem[] = [
  {
    key: "canViewDashboard",
    labelMessageId: "admin.rolePermissions.permissions.dashboard",
    roles: ["admin", "question_editor", "exam_manager"],
  },
  {
    key: "canViewCandidateUsers",
    labelMessageId: "admin.rolePermissions.permissions.candidateUsers",
    roles: ["admin", "exam_manager"],
  },
  { key: "canManageUsers", labelMessageId: "admin.rolePermissions.permissions.users", roles: ["admin"] },
  {
    key: "canResetUserPassword",
    labelMessageId: "admin.rolePermissions.permissions.resetUserPassword",
    roles: ["admin"],
  },
  {
    key: "canImpersonateCandidate",
    labelMessageId: "admin.rolePermissions.permissions.impersonateCandidate",
    roles: ["admin"],
  },
  { key: "canManageSystem", labelMessageId: "admin.rolePermissions.permissions.system", roles: ["admin"] },
  { key: "canViewAuditLogs", labelMessageId: "admin.rolePermissions.permissions.auditLogs", roles: ["admin"] },
  {
    key: "canManageQuestions",
    labelMessageId: "admin.rolePermissions.permissions.questions",
    roles: ["admin", "question_editor"],
  },
  {
    key: "canArchiveQuestions",
    labelMessageId: "admin.rolePermissions.permissions.archiveQuestions",
    roles: ["admin", "question_editor"],
  },
  {
    key: "canDeleteQuestions",
    labelMessageId: "admin.rolePermissions.permissions.deleteQuestions",
    roles: ["admin", "question_editor"],
  },
  {
    key: "canPublishQuestions",
    labelMessageId: "admin.rolePermissions.permissions.publishQuestions",
    roles: ["admin", "question_editor"],
  },
  {
    key: "canManageQuestionExperience",
    labelMessageId: "admin.rolePermissions.permissions.questionExperience",
    roles: ["admin"],
  },
  {
    key: "canManagePapers",
    labelMessageId: "admin.rolePermissions.permissions.papers",
    roles: ["admin", "question_editor", "exam_manager"],
  },
  {
    key: "canManageExams",
    labelMessageId: "admin.rolePermissions.permissions.exams",
    roles: ["admin", "exam_manager"],
  },
  {
    key: "canViewExecution",
    labelMessageId: "admin.rolePermissions.permissions.execution",
    roles: ["admin", "exam_manager"],
  },
  {
    key: "canViewDocker",
    labelMessageId: "admin.rolePermissions.permissions.docker",
    roles: ["admin", "exam_manager"],
  },
  {
    key: "canManageAssets",
    labelMessageId: "admin.rolePermissions.permissions.assets",
    roles: ["admin", "question_editor", "exam_manager"],
  },
  {
    key: "canReview",
    labelMessageId: "admin.rolePermissions.permissions.review",
    roles: ["admin", "exam_manager", "question_editor"],
  },
];
